// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import * as VueGoogleMaps from 'vue2-google-maps'

require('bootstrap')
require('../node_modules/font-awesome/scss/font-awesome.scss')

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCfhfbLs-jVRqe9rd7DKRVlffBgxPxR7Qw',
    libraries: 'places'
  }
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js